import { dayjs } from '@shared/utils';

export function formatExamTime(date: Date | null) {
  if (!date) {
    return '-';
  }

  return `${dayjs(date).format('HH:mm')} น.`;
}
